module.exports = __webpack_public_path__ + "img/Peru.d49a280b.gif";